import Accordion from '@ui/Accordion';
import Toggle from '@ui/Toggle';

type Props = {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
};

const SaleToggleFilterSection = ({ enabled, onChange }: Props) => {
  return (
    <Accordion title="On Sale" startOpen={true}>
      <div className="flex flex-col gap-[1.2rem] p-[1.2rem]">
        <Toggle enabled={enabled} onChange={() => onChange(!enabled)} />
      </div>
    </Accordion>
  );
};

export default SaleToggleFilterSection;
